export default __webpack_public_path__ + "static/media/william_adili.dc2e179e.jpg";